var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 125,
    viewBox: "0 0 169 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.125 18.8599V46.875C161.755 46.875 168.75 53.8696 168.75 62.5V89.8438C168.75 92.002 167.002 93.75 164.844 93.75H153.125V117.188C153.125 121.501 149.626 125 145.312 125H83.3229C88.8789 120.674 93.6456 115.381 97.3705 109.375H137.5V85.9375H105.741C106.077 83.381 106.25 80.7732 106.25 78.125C106.25 69.8014 104.537 61.8778 101.445 54.6875H137.5V31.25H125.781C123.623 31.25 121.875 29.502 121.875 27.3438V15.625H75V25.8207C70.1563 23.2107 64.9087 21.2538 59.375 20.0681V7.8125C59.375 3.49854 62.8735 0 67.1875 0H134.263C136.335 0 138.323 0.822754 139.788 2.2876L150.837 13.335C152.302 14.8022 153.125 16.7871 153.125 18.8599ZM143.359 66.4062C143.359 69.6411 145.984 72.2656 149.219 72.2656C152.454 72.2656 155.078 69.6411 155.078 66.4062C155.078 63.1689 152.454 60.5469 149.219 60.5469C145.984 60.5469 143.359 63.1689 143.359 66.4062Z",
    fill: "#008393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.875 125C72.7634 125 93.75 104.013 93.75 78.125C93.75 52.2367 72.7634 31.25 46.875 31.25C20.9867 31.25 0 52.2367 0 78.125C0 104.013 20.9867 125 46.875 125ZM52.8571 73.3929H68.9286C70.9007 73.3929 72.5 74.9922 72.5 76.9643V80.5357C72.5 82.5078 70.9007 84.1071 68.9286 84.1071H52.8571V100.179C52.8571 102.151 51.2578 103.75 49.2857 103.75H45.7143C43.7422 103.75 42.1429 102.151 42.1429 100.179V84.1071H26.0714C24.0993 84.1071 22.5 82.5078 22.5 80.5357V76.9643C22.5 74.9922 24.0993 73.3929 26.0714 73.3929H42.1429V57.3214C42.1429 55.3493 43.7422 53.75 45.7143 53.75H49.2857C51.2578 53.75 52.8571 55.3493 52.8571 57.3214V73.3929Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDevice);
export default __webpack_public_path__ + "static/media/addDevice.1f72da0289719601051cad4e51eae30d.svg";
export { ForwardRef as ReactComponent };